var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 187.938,
    height: 35.378,
    viewBox: "0 0 187.938 35.378",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_",
    transform: "translate(-6 -238.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    transform: "translate(6 238.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_433",
    "data-name": "Ellipse 433",
    cx: 4.035,
    cy: 4.035,
    r: 4.035,
    transform: "translate(99.058)",
    fill: "#ff6565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M6,250.216v27.79h7.286V265.03H24.908V259.1H13.286v-7.407H25.721V245.7h-15.2A4.51,4.51,0,0,0,6,250.216Z",
    transform: "translate(-6 -243.532)",
    fill: "#ff6565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M91.611,275.1H87.305A1.491,1.491,0,0,0,85.8,276.6v21.949h7.286V276.6a1.448,1.448,0,0,0-1.475-1.505Z",
    transform: "translate(-61.773 -264.08)",
    fill: "#ff6565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M89.053,241.3a3.648,3.648,0,1,0-.06,7.286,3.651,3.651,0,1,0,.06-7.286Z",
    transform: "translate(-61.353 -240.457)",
    fill: "#ff6565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M143.21,273.3a8.551,8.551,0,0,0-7.256,3.764H135.8l-.03-3.252h-1.957a4.51,4.51,0,0,0-4.516,4.516v.09c.03.9.03,1.867.03,2.89v15.958h7.286V283.744a4.629,4.629,0,0,1,.271-1.807,3.949,3.949,0,0,1,3.7-2.77c2.619,0,3.7,2.078,3.7,5.088v13.007h7.286v-13.88C151.611,276.488,148,273.3,143.21,273.3Z",
    transform: "translate(-92.176 -262.818)",
    fill: "#ff6565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M260.312,252.224h-4.306a1.491,1.491,0,0,0-1.505,1.505v.03l.06,8.31c-.03,4.878-2.258,6.383-5,6.383a22.149,22.149,0,0,1-4-.181c-3.1-.6-3.372-4.215-3.4-4.757V240h-2.77a4.51,4.51,0,0,0-4.516,4.516v8.19h-.09c-1.054-1.626-3.282-2.65-6.172-2.65-5.6,0-10.538,4.577-10.508,12.465,0,7.286,4.486,12.043,10,12.043a10.033,10.033,0,0,0,3.131-.512,19.079,19.079,0,0,0,5.45-2.619c.12.06.211.151.331.211a19.073,19.073,0,0,0,5.691,2.589,8.047,8.047,0,0,0,2.047.452,32.335,32.335,0,0,0,5.058.241c7.617,0,12.013-3.583,12.013-12.766l-.06-8.43a1.424,1.424,0,0,0-1.445-1.505ZM234.87,263.575a7.709,7.709,0,0,1-.151,1.656,4.317,4.317,0,0,1-4.215,3.493c-3.041,0-5-2.5-5-6.443,0-3.7,1.686-6.654,5.028-6.654a4.281,4.281,0,0,1,4.215,3.553,9.791,9.791,0,0,1,.09,1.325Z",
    transform: "translate(-154.239 -239.548)",
    fill: "#ff6565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M393.825,273.3c-7.527,0-12.525,4.848-12.525,12.435,0,7.557,5.3,12.074,12.1,12.074,6.293,0,12.345-3.914,12.345-12.5C405.748,278.238,400.991,273.3,393.825,273.3Zm-.241,19.3c-3.1,0-4.787-3.041-4.787-7.045,0-3.462,1.325-7.045,4.817-7.045,3.312,0,4.637,3.553,4.637,7.015C398.251,289.739,396.445,292.6,393.584,292.6Z",
    transform: "translate(-268.302 -262.822)",
    fill: "#ff6565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M491.533,250.026a8.217,8.217,0,0,0-7.076,3.312h-.09V240H481.6a4.51,4.51,0,0,0-4.516,4.516v22.491c0,2.65-.09,5.45-.181,7.015h6.413l.09-3.252h.09a7.7,7.7,0,0,0,7.015,3.794c5.359,0,10.719-4.215,10.719-12.676C501.258,254.693,497.163,250.026,491.533,250.026Zm-2.77,18.788a4.53,4.53,0,0,1-4.306-3.462,6.094,6.094,0,0,1-.12-1.295v-3.463a6.921,6.921,0,0,1,.151-1.355,4.464,4.464,0,0,1,4.275-3.583c3.372,0,5.028,2.89,5.028,6.534,0,4.215-1.927,6.624-5.028,6.624Z",
    transform: "translate(-335.118 -239.548)",
    fill: "#ff6565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M582.651,282.895c-2.86-.994-3.794-1.6-3.794-2.71,0-1.174,1.024-1.9,2.8-1.9a9.732,9.732,0,0,1,2.288.3,2.983,2.983,0,0,0,3.613-2.168l.452-1.837a15.5,15.5,0,0,0-6.594-1.385c-5.811,0-9.544,3.312-9.544,7.708-.03,2.74,1.806,5.42,6.684,7.015,2.71.9,3.432,1.505,3.432,2.71s-.933,1.927-3.131,1.927a9.459,9.459,0,0,1-2.258-.271,4.42,4.42,0,0,0-5.179,3.252l-.12.482a16.669,16.669,0,0,0,7.587,1.656c6.714,0,10.147-3.222,10.147-7.587C588.974,286.689,587.107,284.4,582.651,282.895Z",
    transform: "translate(-401.096 -262.752)",
    fill: "#ff6565"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.16091cc1e62479438e77d8c315f99c87.svg";
export { ForwardRef as ReactComponent };